import { Link } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import PageHero from '../../../components/feature/PageHero';
import SEOHead from '../../../components/feature/SEOHead';
import CountdownTimer from '../../../components/feature/CountdownTimer';

export default function AutomovelPage() {
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Seguro Automóvel Empresarial",
    "provider": {
      "@type": "Organization",
      "name": "IBX Brasil"
    },
    "description": "Consultoria especializada em seguros de frotas empresariais com análise de coberturas, negociação com seguradoras e gestão completa de apólices.",
    "serviceType": "Consultoria em Seguros Automóvel",
    "areaServed": "BR"
  };

  return (
    <>
      <SEOHead
        title="Seguro Automóvel Empresarial | Consultoria Especializada"
        description="Proteja sua frota com consultoria especializada em seguros automóvel. Análise de coberturas, negociação com seguradoras e gestão completa de apólices para empresas."
        canonical="https://ibxbrasil.com.br/servicos/automovel"
        ogImage="https://readdy.ai/api/search-image?query=professional%20business%20consultant%20analyzing%20corporate%20vehicle%20fleet%20insurance%20documents%20on%20modern%20desk%20with%20car%20keys%20and%20insurance%20policy%20papers%20clean%20office%20background%20professional%20lighting%20corporate%20atmosphere%20realistic%20business%20photography%20style&width=1200&height=630&seq=seo-automovel-service&orientation=landscape"
        ogType="service"
        schema={serviceSchema}
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        
        {/* Hero Section */}
        <PageHero
          badge="SERVIÇOS • SEGURO AUTOMÓVEL"
          title="Contratação Profissional de Seguro Automóvel"
          highlightedWord="Automóvel"
          highlightColor="orange"
          subtitle="Análise detalhada de riscos, seleção precisa de coberturas e negociação especializada para proteger seu veículo com economia inteligente."
          benefits={[
            'Redução de até 30% no custo do seguro',
            'Coberturas adequadas ao seu perfil de uso',
            'Análise técnica de cláusulas contratuais',
            'Suporte completo em sinistros'
          ]}
          ctaText="Falar no WhatsApp"
          ctaLink="https://wa.me/5577988080505?text=Olá! Gostaria de saber mais sobre contratação profissional de seguro automóvel."
          ctaSecondary={{
            text: 'Solicitar Análise',
            link: '#contato'
          }}
          backgroundImage="https://readdy.ai/api/search-image?query=professional%20insurance%20consultant%20analyzing%20car%20insurance%20documents%20with%20client%20in%20modern%20office%20clean%20background%20professional%20lighting%20business%20meeting%20atmosphere%20realistic%20photography%20style&width=1920&height=700&seq=automovel-hero-002&orientation=landscape"
          overlayOpacity="medium"
        />

        {/* Benefits Section */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Benefícios da Contratação Profissional
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Proteção completa do seu veículo com economia comprovada
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white border border-gray-200 rounded-lg p-8">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-percent-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Redução de até 30% no Custo</h3>
                <p className="text-gray-600 leading-relaxed">
                  Negociação especializada com múltiplas seguradoras para garantir as melhores condições contratuais e tarifas.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-8">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-shield-check-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Coberturas Adequadas ao Perfil</h3>
                <p className="text-gray-600 leading-relaxed">
                  Análise detalhada do seu perfil de uso e riscos para estruturar coberturas realmente necessárias.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-8">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-team-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Negociação com Múltiplas Seguradoras</h3>
                <p className="text-gray-600 leading-relaxed">
                  Relacionamento direto com as principais seguradoras do mercado para comparação técnica de propostas.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-8">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-file-list-3-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Análise de Cláusulas Contratuais</h3>
                <p className="text-gray-600 leading-relaxed">
                  Revisão técnica de todas as condições contratuais para evitar surpresas em caso de sinistro.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-8">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-customer-service-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Suporte em Sinistros</h3>
                <p className="text-gray-600 leading-relaxed">
                  Acompanhamento técnico durante todo o processo de sinistro para garantir seus direitos.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-8">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-refresh-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Renovação Estratégica</h3>
                <p className="text-gray-600 leading-relaxed">
                  Renegociação anual para manter sempre as melhores condições e coberturas atualizadas.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Como Funciona o Processo
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Metodologia estruturada para garantir proteção e economia
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="relative">
                <div className="bg-white rounded-lg p-8 border-l-4 border-orange-600">
                  <div className="w-12 h-12 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-xl mb-4">
                    1
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">Diagnóstico de Riscos</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Análise do perfil de uso do veículo, histórico de sinistros, região de circulação e necessidades específicas.
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="bg-white rounded-lg p-8 border-l-4 border-orange-600">
                  <div className="w-12 h-12 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-xl mb-4">
                    2
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">Estruturação de Coberturas</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Definição técnica das coberturas necessárias: colisão, roubo, terceiros, assistências e serviços adicionais.
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="bg-white rounded-lg p-8 border-l-4 border-orange-600">
                  <div className="w-12 h-12 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-xl mb-4">
                    3
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">Negociação Especializada</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Cotação com múltiplas seguradoras, análise comparativa técnica e negociação de condições contratuais.
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="bg-white rounded-lg p-8 border-l-4 border-orange-600">
                  <div className="w-12 h-12 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-xl mb-4">
                    4
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">Acompanhamento Contínuo</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Monitoramento durante toda a vigência, suporte em sinistros e preparação para renovação estratégica.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Coverage Types */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Coberturas Analisadas
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Avaliação técnica de todas as coberturas disponíveis no mercado
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex gap-4 bg-white border border-gray-200 rounded-lg p-6">
                <i className="ri-shield-check-line text-3xl text-orange-600 mt-1"></i>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Cobertura Compreensiva</h3>
                  <p className="text-gray-600 text-sm">Colisão, incêndio, roubo e furto com análise de franquias e condições de indenização.</p>
                </div>
              </div>

              <div className="flex gap-4 bg-white border border-gray-200 rounded-lg p-6">
                <i className="ri-user-line text-3xl text-orange-600 mt-1"></i>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Responsabilidade Civil</h3>
                  <p className="text-gray-600 text-sm">Danos materiais e corporais a terceiros com limites adequados ao patrimônio.</p>
                </div>
              </div>

              <div className="flex gap-4 bg-white border border-gray-200 rounded-lg p-6">
                <i className="ri-hospital-line text-3xl text-orange-600 mt-1"></i>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Acidentes Pessoais</h3>
                  <p className="text-gray-600 text-sm">Morte e invalidez de ocupantes com capitais segurados dimensionados.</p>
                </div>
              </div>

              <div className="flex gap-4 bg-white border border-gray-200 rounded-lg p-6">
                <i className="ri-tools-line text-3xl text-orange-600 mt-1"></i>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Assistências 24h</h3>
                  <p className="text-gray-600 text-sm">Reboque, chaveiro, troca de pneus e outros serviços emergenciais.</p>
                </div>
              </div>

              <div className="flex gap-4 bg-white border border-gray-200 rounded-lg p-6">
                <i className="ri-car-washing-line text-3xl text-orange-600 mt-1"></i>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Carro Reserva</h3>
                  <p className="text-gray-600 text-sm">Disponibilidade de veículo substituto durante reparos com prazo adequado.</p>
                </div>
              </div>

              <div className="flex gap-4 bg-white border border-gray-200 rounded-lg p-6">
                <i className="ri-window-line text-3xl text-orange-600 mt-1"></i>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Vidros e Retrovisores</h3>
                  <p className="text-gray-600 text-sm">Cobertura específica sem franquia para danos em vidros e espelhos.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-20 bg-gradient-to-br from-orange-600 to-orange-700">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <CountdownTimer location="paginas-servicos" />
            <h2 className="text-4xl font-bold text-white mb-6">
              Proteja Sua Frota com Segurança e Economia
            </h2>
            <p className="text-xl text-orange-100 mb-8">
              Solicite uma análise gratuita e descubra como economizar mantendo proteção adequada
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="https://wa.me/5577988080505"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-white text-orange-600 rounded-lg font-semibold hover:bg-orange-50 transition-colors duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                <span>Falar no WhatsApp</span>
              </a>
              <a
                href="/contato"
                className="inline-flex items-center gap-2 px-8 py-4 bg-strategic-green-500 text-white font-semibold rounded-lg transition-all duration-300 hover:bg-strategic-green-600 hover:scale-105 hover:shadow-xl whitespace-nowrap"
              >
                Solicitar Cotação
                <i className="ri-arrow-right-line text-xl"></i>
              </a>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}